// src/hooks/useLoadAvailablePlans.ts
import { useState, useEffect, useCallback } from "react";
import { useGetAvailablePlansQuery } from "../redux/api";

export const useLoadAvailablePlans = (projectId: string) => {
    const [shouldFetch, setShouldFetch] = useState(false);
    const { data, isLoading, isError, refetch } = useGetAvailablePlansQuery(
        { project_id: projectId },
        { skip: !shouldFetch, refetchOnMountOrArgChange: true }
    );

    useEffect(() => {
        if (shouldFetch) {
            refetch();
        }
    }, [shouldFetch, refetch]);

    useEffect(() => {
        if (!isLoading && data && !isError) {
            setShouldFetch(false);
        } else if (!isLoading && isError) {
            setShouldFetch(false);
        }
    }, [data, isError, isLoading]);

    const loadAvailablePlans = useCallback(() => {
        setShouldFetch(true);
    }, []);

    return { loadAvailablePlans, isLoading, data, isError };
};